import { useCallback, useRef, useState, useEffect } from "react";
import { fieldsInterface } from "../../../partials/form/FormModel";
import * as Yup from "yup";
import { useIntl } from "react-intl";
import BaseModal from "../../../partials/modals/BaseModal";
import { Button } from "react-bootstrap";
import FormVisitor, { FormHandles } from "../../../partials/form/FormVisitor";
import clsx from "clsx";
import { useStyleContext } from "../../../helpers/StyleContext";
import { toastfy } from "../../../partials/toast/Toast";
import axios from "axios";
import { getAuth } from "../../../../app/modules/auth";

const calculateEndDateByMonths = (startDateStr: string, months: number) => {
  if (!startDateStr || !months) return "";
  const [year, month, day] = startDateStr.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  date.setMonth(date.getMonth() + Number(months));
  return date.toISOString().split('T')[0];
};

export const ModalCreateVisitor = () => {
  const intl = useIntl();
  const { styleState } = useStyleContext();

  const [createUserModal, setCreateUserModal] = useState(false);
  const [userType, setUserType] = useState<"visitante" | "assessor" | "atleta" | "patrocinador" | "funcionario">("visitante");
  const [currentStep, setCurrentStep] = useState(1);
  const [isMocked, setIsMocked] = useState(false);

  const [pdfModal, setPdfModal] = useState(false);
  const [pdfLink, setPdfLink] = useState<string | null>(null);
  const [savedValues, setSavedValues] = useState<any>(null);

  const [associatePlans, setAssociatePlans] = useState<any[]>([]);
  const [atheletePlans, setAthletePlans] = useState<any[]>([]);
  const [sponsorPlans, setSponsorPlans] = useState<any[]>([]);
  const [athleteCategories, setAthleteCategories] = useState<any[]>([]);
  const [athletePositions, setAthletePositions] = useState<any[]>([]);
  const [athleteModules, setAthleteModules] = useState<any[]>([]);
  
  const [employeeRoles, setEmployeeRoles] = useState<any[]>([]); 
  const [sponsorRoles, setSponsorRoles] = useState<any[]>([]); 
  const [associateRoles, setAssociateRoles] = useState<any[]>([]); 
  const [athleteRoles, setAthleteRoles] = useState<any[]>([]); 

  const hasStep2 = ["assessor", "atleta", "patrocinador"].includes(userType);

  useEffect(() => {
    if (createUserModal) {
      const fetchSelects = async () => {
        const apiUrl = process.env.REACT_APP_API_URL;
        const apiToken = getAuth();
        const headers = { Authorization: `Bearer ${apiToken?.api_token}` };

        try {
          const [resPlans, resAthletePlans, resSponsorPlans, resCat, resPos, resMod, resRoles] = await Promise.all([
            axios.get(`${apiUrl}/plans`, { headers }),
            axios.get(`${apiUrl}/technical-committee/plans/active`, { headers }),
            axios.get(`${apiUrl}/sponsor/types/all`, { headers }),
            axios.get(`${apiUrl}/technical-committee/categories`, { headers }),
            axios.get(`${apiUrl}/technical-committee/positions`, { headers }),
            axios.get(`${apiUrl}/technical-committee/modules`, { headers }),
            axios.get(`${apiUrl}/roles?amount=100&page=1&status=all`, { headers }),
          ]);

          const mapPlans = (data: any) => {
            if (!data || !Array.isArray(data.plans)) return [];
            
            const mappedPlans = data.plans.map((item: any) => ({
              label: item.name || item.description || item._id,
              value: item._id,
              planData: item 
            }));

            return [{ label: "Selecione...", value: "", planData: null }, ...mappedPlans];
          };
          
          const mapData = (data: any, labelField: string, valueField: string) => {
            if (!Array.isArray(data)) return [];
            const mappedData = data.map((item: any) => ({
              label: item[labelField] || item.id,
              value: item[valueField] || item.id,
              planData: item 
            }));
            return [{ label: "Selecione...", value: "", planData: null }, ...mappedData];
          };

          if (resPlans.data) setAssociatePlans(mapPlans(resPlans.data));
          
          if (resAthletePlans.data) setAthletePlans(mapData(resAthletePlans.data, "nome", "_id_plano"));
          
          if (resSponsorPlans.data) setSponsorPlans(mapData(resSponsorPlans.data, "nome", "_id_tipo"));
          if (resCat.data) setAthleteCategories(mapData(resCat.data, "nome", "_id_categoria"));
          if (resPos.data) setAthletePositions(mapData(resPos.data, "nome", "_id_posicao"));
          
          if (resMod.data) setAthleteModules(mapData(resMod.data, "nome", "_id_modulo"));
          
          if (resRoles.data && Array.isArray(resRoles.data.roles)) {
            const allRoles = resRoles.data.roles;

            const filteredEmployeeRoles = allRoles.filter((item: any) => 
              String(item._container_id).toLowerCase() === "deecad80a2b97f02377b213b3e8e2021"
            );
            setEmployeeRoles(filteredEmployeeRoles.map((item: any) => ({
              label: item.description || item.name || item._id,
              value: item._id
            })));

            const filteredSponsorRoles = allRoles.filter((item: any) => 
              String(item._container_id).toLowerCase() === "e2f7330728b5eacaef4919ee42bd646d".toLowerCase()
            );
            setSponsorRoles(filteredSponsorRoles.map((item: any) => ({
              label: item.description || item.name || item._id,
              value: item._id
            })));

            const filteredAssociateRoles = allRoles.filter((item: any) => 
              String(item._container_id).toLowerCase() === "3bd596d38e21735d4eb4448dc39a7644".toLowerCase()
            );
            setAssociateRoles(filteredAssociateRoles.map((item: any) => ({
              label: item.description || item.name || item._id,
              value: item._id
            })));

            const filteredAthleteRoles = allRoles.filter((item: any) => 
              String(item._container_id).toLowerCase() === "8807d8ab4397779bf10e9f65873996ba".toLowerCase()
            );
            setAthleteRoles(filteredAthleteRoles.map((item: any) => ({
              label: item.description || item.name || item._id,
              value: item._id
            })));
          }
        } catch (error) {
          console.error("Erro ao carregar opções dos selects", error);
        }
      };
      fetchSelects();
    }
  }, [createUserModal]);

  const formRef = useRef<FormHandles>(null);

  const handleCloseModal = useCallback(() => {
    if (formRef.current) {
      try {
        setSavedValues(formRef.current.getValues());
      } catch (e) {}
    }
    setCreateUserModal(false);
  }, []);

  const handleSuccess = useCallback((apiResponse?: any) => {
    setCreateUserModal(false);
    setUserType("visitante");
    setCurrentStep(1);
    setIsMocked(false);
    setSavedValues(null); 
    
    const linkDocumento = apiResponse?.data?.pdf_link || apiResponse?.pdf_link;

    if (linkDocumento) {
      setPdfLink(linkDocumento);
      setPdfModal(true);
    } else {
      toastfy("success", "Cadastro realizado com sucesso!");
    }
  }, []);

  const FormHandleClear = useCallback(() => {
    setIsMocked(false);
    setSavedValues(null); 
    formRef.current?.handleClearFormikAndPicture();
  }, []);

  const FormHandleSubmit = useCallback(() => {
    formRef.current?.handleSubmit();
  }, []);

  const handleNextStep = async () => {
    if (formRef.current) {
      const errors = await formRef.current.validateForm();
      const step1Fields = getFieldsByType().filter((f: any) => (f.step || 1) === 1).map(f => f.reference);
      const step1Errors = step1Fields.filter(f => errors[f]);

      if (step1Errors.length > 0) {
        const touched = step1Fields.reduce((acc, f) => ({ ...acc, [f]: true }), {});
        formRef.current.setTouched(touched);
        toastfy("error", "Preencha os campos obrigatórios do Passo 1 antes de avançar.");
      } else {
        try {
          const values = formRef.current.getValues();
          const fullName = `${values.first_name || ""} ${values.last_name || ""}`.trim();
          
          if (fullName) formRef.current.setFieldValue("signers_name", fullName);
          if (values.cpf) formRef.current.setFieldValue("signers_cpf", values.cpf);
          if (values.email) formRef.current.setFieldValue("signers_email", values.email);
          
          if (hasStep2 && userType !== "patrocinador") {
            formRef.current.setFieldValue("signers_paper", "contractee");
            
            const fullAddress = [
              values.address,
              values.address_number,
              values.neighborhood,
              values.city,
              values.state,
              values.zipcode
            ].filter(Boolean).join(", ");
            
            if (fullAddress) {
              formRef.current.setFieldValue("signers_address", fullAddress);
            }
          }

        } catch (err) {
          console.error("Erro na transposição de valores", err);
        }
        
        setCurrentStep(2);
      }
    }
  };

  const handlePreviousStep = () => {
    setCurrentStep(1);
  };

  const header = () => {
    const radioOptions: { value: typeof userType; label: string }[] = [
      { value: "visitante", label: "Visitante" },
      { value: "assessor", label: "Associado" },
      { value: "atleta", label: "Atleta" },
      { value: "patrocinador", label: "Patrocinador" },
    ];

    return (
      <div className="d-flex flex-column w-100 border-bottom p-3 gap-3">
        <div className="d-flex justify-content-between align-items-center">
          <b className="fs-3">
            Cadastrar Novo Usuário {hasStep2 ? `- Passo ${currentStep} de 2` : ''}
          </b>
        </div>
        <div className="d-flex gap-4 flex-wrap mt-2">
          {radioOptions.map((option) => (
            <div className="form-check form-check-custom form-check-solid form-check-inline" key={option.value}>
              <input
                className="form-check-input"
                type="radio"
                name="userTypeOptions"
                id={`userType_${option.value}`}
                value={option.value}
                checked={userType === option.value}
                onChange={(e) => {
                  setUserType(e.target.value as typeof userType);
                  setCurrentStep(1); 
                  setIsMocked(false);
                  setSavedValues(null); 
                }}
                style={{ cursor: "pointer" }}
              />
              <label
                className="form-check-label fw-bold"
                htmlFor={`userType_${option.value}`}
                style={{ cursor: "pointer", color: styleState?.secondary_text_color }}
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const isValidCPF = (cpf: string) => {
    if (!cpf) return true;
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    let sum = 0, rest;
    for (let i = 1; i <= 9; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    rest = (sum * 10) % 11;
    if (rest === 10 || rest === 11) rest = 0;
    if (rest !== parseInt(cpf.substring(9, 10))) return false;
    sum = 0;
    for (let i = 1; i <= 10; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    rest = (sum * 10) % 11;
    if (rest === 10 || rest === 11) rest = 0;
    if (rest !== parseInt(cpf.substring(10, 11))) return false;
    return true;
  };

  const isValidCNPJ = (cnpj: string) => {
    if (!cnpj) return true;
    cnpj = cnpj.replace(/\D/g, '');
    if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;
    let size = cnpj.length - 2;
    let numbers = cnpj.substring(0, size);
    let digits = cnpj.substring(size);
    let sum = 0, pos = size - 7;
    for (let i = size; i >= 1; i--) {
      sum += parseInt(numbers.charAt(size - i)) * pos--;
      if (pos < 2) pos = 9;
    }
    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(0))) return false;
    size = size + 1;
    numbers = cnpj.substring(0, size);
    sum = 0; pos = size - 7;
    for (let i = size; i >= 1; i--) {
      sum += parseInt(numbers.charAt(size - i)) * pos--;
      if (pos < 2) pos = 9;
    }
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(1))) return false;
    return true;
  };

  const footer = () => {
    return (
      <div className="d-flex justify-content-between gap-5 w-100">
        <div className="d-flex gap-3">
          {currentStep === 1 ? (
            <Button onClick={FormHandleClear} className="btn btn-sm btn-warning">
              Limpar
            </Button>
          ) : (
            <Button onClick={handlePreviousStep} className="btn btn-sm btn-secondary">
              Voltar
            </Button>
          )}

          {process.env.NODE_ENV === "development" && (
            <Button 
              onClick={() => setIsMocked(!isMocked)} 
              className="btn btn-sm btn-info"
            >
              {isMocked ? "Remover Mock" : "Preencher Mock"}
            </Button>
          )}
        </div>

        {hasStep2 && currentStep === 1 ? (
          <Button onClick={handleNextStep} className="btn btn-sm btn-primary">
            Avançar
          </Button>
        ) : (
          <Button
            onClick={FormHandleSubmit}
            className={clsx({
              "btn btn-sm btn-primary": !styleState.primary_color,
              "text-hover-primary bg-hover-light": styleState.primary_color,
            })}
            style={{
              backgroundColor: styleState?.primary_color,
              color: styleState?.primary_text_color,
            }}
            disabled={isLoading}
          >
            {isLoading ? "" : "Salvar"}
            <span
              className="indicator-progress"
              style={{ display: isLoading ? "block" : "none" }}
            >
              Salvando...
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          </Button>
        )}
      </div>
    );
  };

  const pdfFooter = () => {
    return (
      <div className="d-flex justify-content-end w-100 gap-3">
        <Button onClick={() => setPdfModal(false)} className="btn btn-sm btn-secondary">
          Fechar
        </Button>
        <a 
          href={pdfLink || "#"} 
          target="_blank" 
          rel="noreferrer" 
          className="btn btn-sm btn-primary"
        >
          <i className="fas fa-download me-2"></i> Baixar Documento (Word)
        </a>
      </div>
    );
  };

  const brazilianStates = [
    { value: "AC", label: "Acre" }, { value: "AL", label: "Alagoas" }, { value: "AP", label: "Amapá" },
    { value: "AM", label: "Amazonas" }, { value: "BA", label: "Bahia" }, { value: "CE", label: "Ceará" },
    { value: "DF", label: "Distrito Federal" }, { value: "ES", label: "Espírito Santo" }, { value: "GO", label: "Goiás" },
    { value: "MA", label: "Maranhão" }, { value: "MT", label: "Mato Grosso" }, { value: "MS", label: "Mato Grosso do Sul" },
    { value: "MG", label: "Minas Gerais" }, { value: "PA", label: "Pará" }, { value: "PB", label: "Paraíba" },
    { value: "PR", label: "Paraná" }, { value: "PE", label: "Pernambuco" }, { value: "PI", label: "Piauí" },
    { value: "RJ", label: "Rio de Janeiro" }, { value: "RN", label: "Rio Grande do Norte" }, { value: "RS", label: "Rio Grande do Sul" },
    { value: "RO", label: "Rondônia" }, { value: "RR", label: "Roraima" }, { value: "SC", label: "Santa Catarina" },
    { value: "SP", label: "São Paulo" }, { value: "SE", label: "Sergipe" }, { value: "TO", label: "Tocantins" },
    { value: "EX", label: "Estrangeiro" },
  ];

  const dominantFootOptions = [
    { value: "Destro", label: "Destro" },
    { value: "Canhoto", label: "Canhoto" }
  ];

  const commonFields: any[] = [
    { description: '', reference: "profile_image", colSize: "col-5", field: { element: "profile_image" }, required: true, step: 1 },
    { description: `${intl.formatMessage({ id: "MODULE.FIELDSINTERFACE.NAME" })}`, reference: "first_name", colSize: "col-6 col-md-3", field: { element: "input", type: "text", placeholder: `${intl.formatMessage({ id: "MODULE.FIELDSINTERFACE.NAME.PLACEHOLDER" })}` }, required: true, step: 1 },
    { description: `${intl.formatMessage({ id: "MODULE.FIELDSINTERFACE.LASTNAME" })}`, reference: "last_name", colSize: "col-6 col-md-4", field: { element: "input", type: "text", placeholder: `${intl.formatMessage({ id: "MODULE.FIELDSINTERFACE.LASTNAME.PLACEHOLDER" })}` }, required: true, step: 1 },
    { description: `${intl.formatMessage({ id: "MODULE.FIELDSINTERFACE.CPF" })}`, reference: "cpf", colSize: "col-6 col-md-3", field: { element: "input", type: "cpf", placeholder: `${intl.formatMessage({ id: "MODULE.FIELDSINTERFACE.CPF.PLACEHOLDER" })}` }, required: true, step: 1 },
    { description: `${intl.formatMessage({ id: "MODULE.FIELDSINTERFACE.CELPHONE" })}`, reference: "celphone", colSize: "col-6 col-md-4", field: { element: "input", placeholder: `${intl.formatMessage({ id: "MODULE.FIELDSINTERFACE.CELPHONE.PLACEHOLDER" })}` }, required: true, step: 1 },
    { description: "E-mail", reference: "email", colSize: "col-6 col-md-5", field: { element: "input", type: "email", placeholder: `${intl.formatMessage({ id: "MODULE.FIELDSINTERFACE.EMAIL.PLACEHOLDER" })}` }, required: true, step: 1 },
  ];

  const signerFields: any[] = [
    { description: "Nome do Signatário / Responsável", reference: "signers_name", colSize: "col-6", field: { element: "input", type: "text", placeholder: "Nome completo do signatário" }, required: true, step: 2 },
    { description: "CPF do Signatário / Responsável", reference: "signers_cpf", colSize: "col-6", field: { element: "input", type: "cpf", placeholder: "000.000.000-00" }, required: true, step: 2 },
    { description: "E-mail do Signatário / Responsável", reference: "signers_email", colSize: "col-6", field: { element: "input", type: "email", placeholder: "email@exemplo.com" }, required: true, step: 2 },
    { description: "Endereço do Signatário / Responsável", reference: "signers_address", colSize: "col-6", field: { element: "input", type: "text", placeholder: "Endereço completo" }, required: true, step: 2 },
  ];

  const handlePlanChange = (e: any) => {
    if (!formRef.current) return;
    
    const selectedPlanId = e.target.value;
    const plan = associatePlans.find((p) => String(p.value) === String(selectedPlanId));
    
    if (plan && plan.planData) {
      formRef.current.setFieldValue("value", plan.planData.amount ?? "");
      formRef.current.setFieldValue("duration", plan.planData.duration ?? "");
      
      if (plan.planData.duration) {
        const values = formRef.current.getValues();
        const startDateStr = values.start_date || new Date().toISOString().split('T')[0];
        formRef.current.setFieldValue("end_date", calculateEndDateByMonths(startDateStr, plan.planData.duration));
      }
    } else {
      formRef.current.setFieldValue("value", "");
      formRef.current.setFieldValue("duration", "");
      formRef.current.setFieldValue("end_date", "");
    }
  };

  const handleSponsorPlanChange = (e: any) => {
    if (!formRef.current) return;
    const selectedId = e.target.value;
    const plan = sponsorPlans.find((p) => String(p.value) === String(selectedId));

    if (plan && plan.planData && plan.planData.tempo_exibicao) {
      formRef.current.setFieldValue("duration", plan.planData.tempo_exibicao);
      const values = formRef.current.getValues();
      const startDateStr = values.data_inicio_vigencia || new Date().toISOString().split('T')[0];
      formRef.current.setFieldValue("data_fim_vigencia", calculateEndDateByMonths(startDateStr, plan.planData.tempo_exibicao));
    }
  };

  const handleSponsorStartDateChange = (e: any) => {
    if (!formRef.current) return;
    const newDate = e.target.value;
    formRef.current.setFieldValue("data_inicio_vigencia", newDate);
    
    const values = formRef.current.getValues();
    if (values.duration) {
      formRef.current.setFieldValue("data_fim_vigencia", calculateEndDateByMonths(newDate, values.duration));
    }
  };

  const step2FieldsAssociado: any[] = [
    { description: "Plano", reference: "_id_plan", colSize: "col-6 col-md-6", field: { element: "select", options: associatePlans, placeholder: "Selecione um plano...", onChange: handlePlanChange }, required: true, step: 2 },
    { description: "Função / Perfil", reference: "role", colSize: "col-6 col-md-6", field: { element: "select", options: associateRoles, placeholder: "Selecione uma função..." }, required: true, step: 2 },
    { description: "Valor (R$)", reference: "value", colSize: "col-6 col-md-5", disabled: true, readOnly: true, field: { element: "input", type: "text", className: "form-control bg-secondary form-control-sm" }, required: true, step: 2 },
    { description: "Duração (Meses)", reference: "duration", colSize: "col-6 col-md-3", disabled: true, readOnly: true, field: { element: "input", type: "number", className: "form-control bg-secondary form-control-sm" }, required: true, step: 2 },
    { description: "Dia de vencimento", reference: "charge_payment_day", colSize: "col-6 col-md-4", field: { element: "input", type: "number", placeholder: "Ex: 10" , value: 10 }, required: true, step: 2 },
    { description: "Inicia em", reference: "start_date", colSize: "col-6", disabled: true, readOnly: true, field: { element: "input", type: "date", className: "form-control bg-secondary form-control-sm" }, required: true, step: 2 },
    { description: "Fim Vigência", reference: "end_date", colSize: "col-6", disabled: true, readOnly: true, field: { element: "input", type: "date", className: "form-control bg-secondary form-control-sm" }, required: true, step: 2 },
    ...signerFields,
  ];

  const step2FieldsAtleta: any[] = [
    { description: "Plano Associado", reference: "_id_plan", colSize: "col-4 col-md-4", field: { element: "select", options: associatePlans, placeholder: "Selecione plano associado", onChange: handlePlanChange }, required: true, step: 2 },
    { description: "Plano Atleta", reference: "_id_athlete_plan", colSize: "col-4 col-md-4", field: { element: "select", options: atheletePlans, placeholder: "Selecione o plano atleta" }, required: true, step: 2 },
    { description: "Função / Perfil", reference: "role", colSize: "col-4 col-md-4", field: { element: "select", options: athleteRoles, placeholder: "Selecione uma função..." }, required: true, step: 2 },
    { description: "Valor (R$)", reference: "value", colSize: "col-6 col-md-5", disabled: true, readOnly: true, field: { element: "input", type: "text", className: "form-control bg-secondary form-control-sm" }, required: true, step: 2 },
    { description: "Duração (Meses)", reference: "duration", colSize: "col-6 col-md-3", disabled: true, readOnly: true, field: { element: "input", type: "number", className: "form-control bg-secondary form-control-sm" }, required: true, step: 2 },
    { description: "Dia de vencimento", reference: "charge_payment_day", colSize: "col-6 col-md-4", field: { element: "input", type: "number", placeholder: "Ex: 10", value: 10 }, required: true, step: 2 },
    { description: "Inicia em", reference: "start_date", colSize: "col-6", disabled: true, readOnly: true, field: { element: "input", type: "date", className: "form-control bg-secondary form-control-sm" }, required: true, step: 2 },
    { description: "Fim Vigência", reference: "end_date", colSize: "col-6", disabled: true, readOnly: true, field: { element: "input", type: "date", className: "form-control bg-secondary form-control-sm" }, required: true, step: 2 },
    ...signerFields,
  ];

  const step1FieldsPatrocinador: any[] = [
    { description: "Nome do Responsável", reference: "first_name", colSize: "col-6 col-md-3", field: { element: "input", type: "text", placeholder: "Ex: João" }, required: true, step: 1 },
    { description: "Sobrenome", reference: "last_name", colSize: "col-6 col-md-3", field: { element: "input", type: "text", placeholder: "Ex: Silva" }, required: true, step: 1 },
    { description: "CPF do Responsável", reference: "cpf", colSize: "col-6 col-md-3", field: { element: "input", type: "cpf", placeholder: "000.000.000-00" }, required: true, step: 1 },
    { description: "Celular / WhatsApp", reference: "celphone", colSize: "col-6 col-md-3", field: { element: "input", placeholder: "(11) 90000-0000" }, required: true, step: 1 },
    { description: "E-mail Corporativo / Login", reference: "email", colSize: "col-12 col-md-4", field: { element: "input", type: "email", placeholder: "contato@empresa.com" }, required: true, step: 1 },
    { description: "Senha de Acesso", reference: "password", colSize: "col-6 col-md-4", field: { element: "input", type: "password", placeholder: "******" }, required: true, step: 1 },
    { description: "Confirmar Senha", reference: "confirm_password", colSize: "col-6 col-md-4", field: { element: "input", type: "password", placeholder: "******" }, required: true, step: 1 },
  ];

  const step2FieldsPatrocinador: any[] = [
    { description: "Nome da Empresa", reference: "nome", colSize: "col-12 col-md-6", field: { element: "input", type: "text", placeholder: "Ex: Nike Sports" }, required: true, step: 2 },
    { description: "CNPJ", reference: "cnpj", colSize: "col-6 col-md-6", field: { element: "input", type: "text", placeholder: "00.000.000/0000-00" }, required: true, step: 2 },
    { description: "Tipo de Cota", reference: "_id_tipo", colSize: "col-6 col-md-4", field: { element: "select", options: sponsorPlans, placeholder: "Selecione o plano...", onChange: handleSponsorPlanChange }, required: true, step: 2 },
    { description: "Função (Permissões de Acesso)", reference: "_id_funcao", colSize: "col-6 col-md-4", field: { element: "select", options: sponsorRoles, placeholder: "Selecione a função..." }, required: true, step: 2 },
    { description: "Website", reference: "link_site", colSize: "col-12 col-md-4", field: { element: "input", type: "text", placeholder: "https://..." }, required: true, step: 2 },
    { description: "Início Vigência", reference: "data_inicio_vigencia", colSize: "col-6", field: { element: "input", type: "date", onChange: handleSponsorStartDateChange }, required: true, step: 2 },
    { description: "Fim Vigência", reference: "data_fim_vigencia", colSize: "col-6", field: { element: "input", type: "date" }, required: true, step: 2 },
    { description: "Logo da Empresa", reference: "file", colSize: "col-12", field: { element: "profile_image" }, required: true, step: 2 }, 
  ];

  const getFieldsByType = (): any[] => {
    switch (userType) {
      case "visitante":
        return [
          ...commonFields,
          { description: `${intl.formatMessage({ id: "MODULE.FIELDSINTERFACE.QRCODE" })}`, reference: "content", colSize: "col-12 col-md-6", field: { element: "input" }, required: true, step: 1 },
          { description: `${intl.formatMessage({ id: "MODULE.FIELDSINTERFACE.INSTAGRAM" })}`, reference: "instagram", colSize: "col-12 col-md-6", field: { type: "instagram", element: "input", id: "teste", placeholder: `${intl.formatMessage({ id: "MODULE.FIELDSINTERFACE.INSTAGRAM.PLACEHOLDER" })}` }, required: false, step: 1 },
        ];
      case "assessor":
        return [
          ...commonFields,
          { description: `${intl.formatMessage({ id: "MODULE.FIELDSINTERFACE.QRCODE" })}`, reference: "content", colSize: "col-12 col-md-4", field: { element: "input" }, required: true, step: 1 },
          { description: "Senha", reference: "password", colSize: "col-12 col-md-4", field: { element: "input", type: "password", placeholder: "Senha" }, required: true, step: 1 },
          { description: "Confirmar Senha", reference: "confirm_password", colSize: "col-12 col-md-4", field: { element: "input", type: "password", placeholder: "Confirme a senha inserida" }, required: true, step: 1 },
          { description: "CEP", reference: "zipcode", colSize: "col-12 col-md-2", field: { element: "input", type: "text", placeholder: "00000-000" }, required: true, step: 1 },
          { description: "Endereço", reference: "address", colSize: "col-12 col-md-8", field: { element: "input", type: "text", placeholder: "Endereço" }, required: true, step: 1 },
          { description: "Número", reference: "address_number", colSize: "col-12 col-md-2", field: { element: "input", type: "text", placeholder: "Número" }, required: true, step: 1 },
          { description: "Bairro", reference: "neighborhood", colSize: "col-12 col-md-4", field: { element: "input", type: "text", placeholder: "Bairro" }, required: true, step: 1 },
          { description: "Cidade", reference: "city", colSize: "col-12 col-md-4", field: { element: "input", type: "text", placeholder: "Cidade" }, required: true, step: 1 },
          { description: "Estado", reference: "state", colSize: "col-12 col-md-4", field: { element: "select", options: brazilianStates, placeholder: "Selecione" }, required: true, step: 1 },
          ...step2FieldsAssociado, 
        ];
      case "atleta":
        return [
          ...commonFields,
          { description: "Módulo", reference: "_id_modulo", colSize: "col-12 col-md-3", field: { element: "select", options: athleteModules, placeholder: "Selecione..." }, required: true, step: 1 },
          { description: "Categoria", reference: "_id_categoria", colSize: "col-12 col-md-3", field: { element: "select", options: athleteCategories, placeholder: "Selecione..." }, required: true, step: 1 },
          { description: "Posição Principal", reference: "_id_posicao", colSize: "col-12 col-md-3", field: { element: "select", options: athletePositions, placeholder: "Selecione..." }, required: true, step: 1 },
          { description: "Pé Preferencial", reference: "pe_preferencial", colSize: "col-12 col-md-3", field: { element: "select", options: dominantFootOptions, placeholder: "Selecione..." }, required: true, step: 1 },
          { description: "Senha", reference: "password", colSize: "col-12 col-md-6", field: { element: "input", type: "password", placeholder: "Senha" }, required: true, step: 1 },
          { description: "Confirmar Senha", reference: "confirm_password", colSize: "col-12 col-md-6", field: { element: "input", type: "password", placeholder: "Confirme a senha inserida" }, required: true, step: 1 },
          { description: "CEP", reference: "zipcode", colSize: "col-12 col-md-2", field: { element: "input", type: "text", placeholder: "00000-000" }, required: true, step: 1 },
          { description: "Endereço", reference: "address", colSize: "col-12 col-md-8", field: { element: "input", type: "text", placeholder: "Endereço" }, required: true, step: 1 },
          { description: "Número", reference: "address_number", colSize: "col-12 col-md-2", field: { element: "input", type: "text", placeholder: "Número" }, required: true, step: 1 },
          { description: "Bairro", reference: "neighborhood", colSize: "col-12 col-md-4", field: { element: "input", type: "text", placeholder: "Bairro" }, required: true, step: 1 },
          { description: "Cidade", reference: "city", colSize: "col-12 col-md-4", field: { element: "input", type: "text", placeholder: "Cidade" }, required: true, step: 1 },
          { description: "Estado", reference: "state", colSize: "col-12 col-md-4", field: { element: "select", options: brazilianStates, placeholder: "Selecione" }, required: true, step: 1 },
          ...step2FieldsAtleta, 
        ];
      case "patrocinador":
        return [
          ...step1FieldsPatrocinador,
          ...step2FieldsPatrocinador, 
        ];
      case "funcionario":
        return [
          ...commonFields,
          { description: "Função / Perfil de Acesso", reference: "role", colSize: "col-4", field: { element: "select", options: employeeRoles, placeholder: "Selecione..." }, required: true, step: 1 },
          { description: "Senha", reference: "password", colSize: "col-6 col-md-4", field: { element: "input", type: "password", placeholder: "Insira sua senha" }, required: true, step: 1 },
          { description: "Confirmar senha", reference: "confirm_password", colSize: "col-6 col-md-4", field: { element: "input", type: "password", placeholder: "Confirme a senha inserida" }, required: true, step: 1 },
        ];
      default:
        return commonFields;
    }
  };

  const getValidationSchema = () => {
    let schema: any = {};
    
    if (userType === "patrocinador") {
      schema.file = Yup.mixed().test("is-file", "A logo da empresa é obrigatória", (value) => value !== "" && value !== undefined && value !== null);
    } else {
      schema.profile_image = Yup.mixed().test("is-file", "A foto de perfil é obrigatória", (value) => value !== "" && value !== undefined && value !== null);
    }

    schema.first_name = Yup.string().required(`${intl.formatMessage({ id: "MODULE.VALIDATIONSCHEMA.REQUIRED_NAME" })}`);
    schema.last_name = Yup.string().required(`${intl.formatMessage({ id: "MODULE.VALIDATIONSCHEMA.REQUIRED_LAST_NAME" })}`);
    schema.cpf = Yup.string().test("valid-cpf", `${intl.formatMessage({ id: "MODULE.VALIDATIONSCHEMA.REQUIRED_CPF_INVALID" })}`, (value) => value === "" || isValidCPF(value ?? "")).required(`${intl.formatMessage({ id: "MODULE.VALIDATIONSCHEMA.REQUIRED_CPF" })}`);
    schema.celphone = Yup.string().test("celphone", `${intl.formatMessage({ id: "MODULE.VALIDATIONSCHEMA.REQUIRED_CELPHONE_INVALID" })}`, (value) => { if (!value) return false; const numericValue = value.replace(/\D/g, ""); return numericValue.length === 11; }).required("O celular é obrigatório");
    schema.email = Yup.string().email(`${intl.formatMessage({ id: "MODULE.VALIDATIONSCHEMA.REQUIRED_EMAIL" })}`).required("O E-mail é obrigatório");

    if (["visitante", "assessor"].includes(userType)) {
      schema.content = Yup.string().required(`${intl.formatMessage({ id: "MODULE.FIELDSINTERFACE.REQUIRED_CONTENT" })}`);
    }

    if (["assessor", "atleta", "patrocinador", "funcionario"].includes(userType)) {
      schema.password = Yup.string().required("Senha é obrigatória");
      schema.confirm_password = Yup.string()
        .oneOf([Yup.ref('password'), null], 'As senhas devem corresponder')
        .required("Confirmação de senha é obrigatória");
    }

    if (["assessor", "atleta"].includes(userType)) {
      schema.zipcode = Yup.string().required("CEP é obrigatório");
      schema.address = Yup.string().required("Endereço é obrigatório");
      schema.address_number = Yup.string().required("Número é obrigatório");
      schema.neighborhood = Yup.string().required("Bairro é obrigatório");
      schema.city = Yup.string().required("Cidade é obrigatória");
      schema.state = Yup.string().required("Estado é obrigatório");
    }

    if (userType === "atleta") {
      schema._id_modulo = Yup.string().required("O Módulo é obrigatório");
      schema._id_categoria = Yup.string().required("A Categoria é obrigatória");
      schema._id_posicao = Yup.string().required("A Posição é obrigatória");
      schema.pe_preferencial = Yup.string().required("O Pé Preferencial é obrigatório");
    }

    if (userType === "funcionario") {
      schema.role = Yup.string().required("Função é obrigatória");
    }
    
    if (hasStep2) {
      if (userType === "patrocinador") {
        schema.nome = Yup.string().required("Nome da Empresa Obrigatório");
        schema.cnpj = Yup.string().test("valid-cnpj", "CNPJ Inválido", (value) => value === "" || isValidCNPJ(value ?? "")).required("CNPJ Obrigatório");
        schema._id_tipo = Yup.string().required("Tipo de Cota é obrigatório");
        schema._id_funcao = Yup.string().required("Função de acesso é obrigatória");
        schema.link_site = Yup.string().required("Website é obrigatório");
        schema.data_inicio_vigencia = Yup.string().required("Data de início é obrigatória");
        schema.data_fim_vigencia = Yup.string().required("Data de fim é obrigatória");
      } else {
        schema._id_plan = Yup.string().required("Plano é obrigatório");
        
        if (userType === "atleta") {
          schema._id_athlete_plan = Yup.string().required("Plano Atleta é obrigatório");
        }
        
        schema.role = Yup.string().required("Função é obrigatória");
        schema.value = Yup.string().required("Valor é obrigatório");
        schema.duration = Yup.number().typeError("Deve ser numérico").required("Duração é obrigatória");
        schema.charge_payment_day = Yup.number().typeError("Deve ser numérico").required("Dia de vencimento é obrigatório");
        schema.start_date = Yup.string().required("Data de início é obrigatória");
        schema.end_date = Yup.string().required("Data de fim de vigência é obrigatória");
        
        schema.signers_name = Yup.string().required("Nome do signatário é obrigatório");
        schema.signers_cpf = Yup.string().test("valid-cpf-signer", "CPF do signatário inválido", (value) => value === "" || isValidCPF(value ?? "")).required("CPF do signatário é obrigatório");
        schema.signers_email = Yup.string().email("E-mail inválido").required("E-mail do signatário é obrigatório");
        schema.signers_address = Yup.string().required("Endereço do signatário é obrigatório");
      }
    }
    return Yup.object().shape(schema);
  };

  const getInitialValues = () => {
    const currentFields = getFieldsByType();
    const initialValues: any = {};
    
    const d = new Date();
    const today = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    
    if (hasStep2 && userType !== "patrocinador") {
      initialValues.signers_paper = "contractee";
    }

    const mockData: Record<string, any> = {
      first_name: "Responsavel",
      last_name: "Sobrenome",
      cpf: "749.323.410-83", 
      celphone: "11988887777",
      email: "wagnerfariadossantos@gmail.com",
      content: "1000001592", 
      instagram: "@excelencecode",
      password: "SenhaFort3!",
      confirm_password: "SenhaFort3!",
      menor: true,
      zipcode: "01001-000",
      address: "Rua do Fictício",
      address_number: "999",
      neighborhood: "Bairro Teste",
      city: "São Paulo",
      state: "SP", 
      nome: "Empresa Patrocinadora Teste",
      cnpj: "6345763547465",
      link_site: "www.excelencecode.com",
      pe_preferencial: "Destro",
      _id_modulo: 1 
    };
    
    currentFields.forEach((field) => {
      let valueToSet: any = field.field.element === "checkbox" ? false : "";

      if (field.reference === "charge_payment_day") valueToSet = 10;
      if (field.reference === "start_date" || field.reference === "data_inicio_vigencia") valueToSet = today;

      if (isMocked) {
        if (field.reference === "_id_plan" && associatePlans.length > 1) valueToSet = associatePlans[1].value;
        else if (field.reference === "_id_athlete_plan" && atheletePlans.length > 1) valueToSet = atheletePlans[1].value;
        else if (field.reference === "_id_tipo" && sponsorPlans.length > 1) valueToSet = sponsorPlans[1].value;
        else if (field.reference === "_id_funcao" && sponsorRoles.length > 0) valueToSet = sponsorRoles[0].value;
        else if (field.reference === "_id_categoria" && athleteCategories.length > 1) valueToSet = athleteCategories[1].value;
        else if (field.reference === "_id_posicao" && athletePositions.length > 1) valueToSet = athletePositions[1].value;
        else if (field.reference === "_id_modulo" && athleteModules.length > 1) valueToSet = athleteModules[1].value;
        else if (field.reference === "role") {
          if (userType === "funcionario" && employeeRoles.length > 0) valueToSet = employeeRoles[0].value;
          else if (userType === "assessor" && associateRoles.length > 0) valueToSet = associateRoles[0].value;
          else if (userType === "atleta" && athleteRoles.length > 0) valueToSet = athleteRoles[0].value;
        }
        else if (mockData[field.reference] !== undefined) {
          valueToSet = mockData[field.reference];
        }
      }

      if (savedValues && savedValues[field.reference] !== undefined) {
        valueToSet = savedValues[field.reference];
      }

      initialValues[field.reference] = valueToSet;
    });

    return initialValues;
  };

  const getApiModule = () => {
    switch (userType) {
      case "visitante": return "topbar/visitors/create";
      case "assessor": return "topbar/associates/create"; 
      case "atleta": return "topbar/athletes/create";     
      case "patrocinador": return "topbar/sponsors/create"; 
      case "funcionario": return "topbar/employees/create"; 
      default: return "topbar/visitors/create";
    }
  };

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const handleIsLoading = (isLoading: boolean) => {
    setIsLoading(isLoading);
  };

  return (
    <>
      <div
        className="bg-success rounded cursor-pointer"
        onClick={() => {
          setCreateUserModal(true);
        }}
      >
        <i className="fas fa-plus m-0 text-white p-4"></i>
      </div>

      <BaseModal
        showModal={createUserModal}
        closeModal={handleCloseModal} 
        footer={true}
        footerBody={footer()}
        header={header()}
        dialogClassName="modal-lg"
      >
        <BaseModal.Body>
          <FormVisitor
            key={`${userType}-${isMocked}`} 
            handleIsLoading={handleIsLoading}
            closeModal={handleCloseModal} 
            onSuccess={handleSuccess} 
            fields={getFieldsByType()} 
            module={getApiModule()} 
            validationSchema={getValidationSchema()} 
            validationInitialValues={getInitialValues()}
            currentStep={currentStep} 
            ref={formRef}
          />
        </BaseModal.Body>
      </BaseModal>

      <BaseModal
        showModal={pdfModal}
        closeModal={() => setPdfModal(false)}
        title="Contrato Eletrônico Gerado"
        dialogClassName="modal-xl"
        footer={true}
        footerBody={pdfFooter()}
      >
        <BaseModal.Body>
          <div className="w-100" style={{ height: "65vh" }}>
            {pdfLink ? (
              <iframe
                src={`https://docs.google.com/gview?url=${encodeURIComponent(pdfLink)}&embedded=true`}
                width="100%"
                height="100%"
                style={{ border: "none", borderRadius: "8px" }}
                title="Visualização do Contrato"
              />
            ) : (
              <div className="d-flex align-items-center justify-content-center h-100">
                <span className="text-muted fs-4">Documento não encontrado ou ainda sendo processado.</span>
              </div>
            )}
          </div>
        </BaseModal.Body>
      </BaseModal>
    </>
  );
};